import { render } from "./LoginSignUpPage.vue?vue&type=template&id=e23193fe&ts=true"
import script from "./LoginSignUpPage.vue?vue&type=script&lang=ts"
export * from "./LoginSignUpPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__